<template>
  <a-popover trigger="click" placement="bottomRight" :visible="showVisible"
             @visibleChange="()=>{showVisible=!showVisible}">
    <template slot="content" >
      <a-input-search v-model="name" placeholder="请输入应用名" allowClear @change="searchApplication"></a-input-search>
      <div style="max-height: 300px;overflow-y: scroll">
        <div style="cursor: pointer;margin-top: 5px;padding: 8px;border-radius: 5px;font-size: 18px;"
             :style="{background: applicationItem.app_id===application.app_id?'rgba(24,144,255,0.5)':'rgba(119, 163, 160, 0.2)'}"
             @click="changeApplication(applicationItem)"
             v-for="(applicationItem,applicationIndex) in applicationShow">
          <img :src="applicationItem.icon" style="height: 35px;border-radius: 5px">
          {{applicationItem.app_name}}
        </div>
      </div>
    </template>
    <div style="font-size: 20px;cursor: pointer;padding: 0 5px">
      <img v-if="application" :src="application.icon" style="height: 40px;border-radius: 5px;">
      {{application?application.app_name:'请选择应用'}}
      <a-icon type="caret-down" />
    </div>
  </a-popover>
</template>

<script>
export default {
  name: "ApplicationPanel",
  data(){
    return {
      showVisible:false,
      application:undefined,
      applicationShow:[],
      name:''
    }
  },
  props:["applicationList"],
  watch:{
    applicationList: {
      handler(newName, oldName) {
        this.applicationShow = this.applicationList
        if (this.applicationList.length>0){
          let _that = this
          let _index = this.applicationList.findIndex(item => {
            return item.app_id==Number(localStorage.getItem("app_id"))
          })
          if (_index===-1) _index = 0
          this.application = this.applicationList[_index]
          this.$store.commit("setAppId",this.application.app_id)
          let _query = JSON.parse(JSON.stringify(this.$route.query))
          _query.app_id = this.$store.getters.getAppId
          this.$router.push({query:_query})
        }

      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
  },
  methods:{
    changeApplication(application){
      this.application = application
      this.$store.commit("setAppId",this.application.app_id)
      let _query = JSON.parse(JSON.stringify(this.$route.query))
      _query.app_id = this.$store.getters.getAppId
      this.$router.push({query:_query})
      this.showVisible = false
    },
    searchApplication(){
      if (!this.name){
        this.applicationShow = this.applicationList
      }else{
        let _value = this.name.toLowerCase()
        this.applicationShow = this.applicationList.filter(item => {
          return item.app_name.toLowerCase().indexOf(_value)!==-1
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/V1/ApplicationPanel.vue